import {StoryMessage} from "../../Server/DB/storyMessages/@StoryMessage.js";
import {CheckAgeFilter, ParseSpecialFilter, SpecialFilter} from "./@Shared.js";

/**
 * Check whether a StoryMessage passes all of the filters encoded in filterText.
 *
 * filterText is a space-separated list of tokens. Each token is either:
 *   - a plain word → the message's content must contain it (case-insensitive)
 *   - a special filter of the form  <keyword><comparison><value>
 *     Supported keywords:
 *       age  – filter by how long ago the message was created (e.g. "age<1h", "age>2d")
 *       role – filter by role, e.g. "role:user" or "role:assistant"
 *
 * Returns true if the message passes every token, false otherwise.
 */
export function DoesMessagePassFilter(msg: StoryMessage, filterText: string): boolean {
	const tokens = filterText.trim().toLowerCase().split(/\s+/).filter(t=>t.length > 0);
	if (tokens.length == 0) return true;

	for (const token of tokens) {
		const special = ParseSpecialFilter(token);
		if (special != null) {
			if (!DoesMessagePassSpecialFilter(msg, special)) return false;
		} else {
			if (!msg.content.toLowerCase().includes(token)) return false;
		}
	}
	return true;
}

function DoesMessagePassSpecialFilter(msg: StoryMessage, filter: SpecialFilter): boolean {
	const {keyword, comparison, value} = filter;

	if (keyword == "age") {
		return CheckAgeFilter(msg.createdAt, comparison, value);
	}
	if (keyword == "id") {
		if (comparison == ":") return msg.id == value;
		return true; // non-equality comparisons don't apply to id
	}
	if (keyword == "role") {
		if (comparison == ":") return msg.role.toLowerCase() == value;
		return true; // non-equality comparisons don't apply to role
	}

	// unknown keyword – don't filter out the message
	return true;
}